import { SimpleDataStore, useMemoryData } from '../storage/index.js';
import { CrystalRedux } from './crystal-redux.js';
import { hostReducer } from './host.js';
import { modalReducer } from './modal.js';
const reduxHost = useMemoryData('redux-host', () => new SimpleDataStore());
export const globalReducers = {
    modal: modalReducer,
    host: hostReducer,
};
export function initializeReduxHost(initialReducers, initialState, env) {
    if (isReduxHostInitialized()) {
        throw new Error('Redux host has been initialized already.');
    }
    reduxHost().set(new CrystalRedux(initialReducers, initialState, env));
}
export function isReduxHostInitialized() {
    return !!reduxHost().get();
}
export function getReduxHost() {
    if (!isReduxHostInitialized()) {
        initializeReduxHost(globalReducers);
    }
    return reduxHost().get();
}
export function getReduxStore() {
    return getReduxHost().getStore();
}
export function TEST_ONLY_removeHost() {
    reduxHost().remove();
}
//# sourceMappingURL=redux-host.js.map